import { Flex } from '@radix-ui/themes';
import { Key } from 'react';
import { FacetItem } from './FacetItem';

interface FacetFlowProps<T> {
    facets: T[];
    isActive: (facet: T) => boolean;
    onSelect: (facet: T) => void;
    getLabel: (facet: T) => string;
    getKey: (facet: T) => Key;
    getCounts?: (facet: T) => {
        total: number;
        matches: number;
    };
}

export const FacetFlow = <T,>({
    facets,
    isActive,
    onSelect,
    getLabel,
    getKey,
    getCounts,
}: FacetFlowProps<T>) => (
    <Flex gap='2' wrap='wrap' mt='3'>
        {facets.map((facet) => {
            const { total = 0, matches = 0 } = getCounts?.(facet) ?? {};

            return (
                <FacetItem
                    key={getKey(facet)}
                    label={getLabel(facet)}
                    total={total}
                    matches={matches}
                    isActive={isActive(facet)}
                    onClick={() => onSelect(facet)}
                />
            );
        })}
    </Flex>
);
